// onboard
import { useEffect, useState } from "react";
import { useHistory } from 'react-router-dom';

import WebbDividerSmall from "../webb/webb-divider-sm";
import WebbDividerMedium from "../webb/webb-divider-md";
import WebbModuleInfo from "../webb/webb-module-info";
import WebbLoader from "../webb/webb-loader";
import FormNeeded from "../webb/form-needed";

import { GetAuthUser, GetNewUser } from "../../services/srvc-auth-user";


export default function XummModule() {

  const asset = GetAuthUser();
  const usrx = GetNewUser();
  console.log(usrx)
  const history = useHistory();

  const [loading, setLoading] = useState(false);
  const [form, setForm] = useState(false);
  const [text, setText] = useState('');

  const [data, setData] = useState({
    acnt: '',
    ntwk: 'devnet-nft'
  });

  // form validation
  useEffect( () => {
    setForm(false)
    if (data.acnt !=='') 
      setForm(true);
  },[data]);



  const handleChange = async(key, val) => {
    setData({ ...data, [key]: val });
  }

  const handleSubmit = async (e) => {
    e.preventDefault();

  }

  if (loading){ return ( <> <WebbLoader /> </> ) }
  
  return (
  <>
    {/* info */}
    <WebbModuleInfo data={{ text: 'Please Link Your NFT Devnet Account' }} />

    
    

    <WebbDividerMedium />
    {/* text */}
    <div className="mb-3">
      <p className="small mt-2">
        Note: This only works with NFT-Devnet Accounts.
        Please get one at 
        <a href='https://xrpl.org/xrp-testnet-faucet.html' 
          target={'_blank'} className='ms-2 fw-bold'
          >NFT Devnet Credentials 
        </a>
      </p>
    </div>

    <WebbDividerMedium />
    <WebbDividerMedium />

  </>
  )
}